<script>
import Router from 'svelte-spa-router'
import Tour from './Fullscreen/Tour.svelte'
import CreateFactory from './Dashboard/CreateFactory.svelte'
import FactorySaved from './Fullscreen/FactorySaved.svelte';
import ProductSaved from './Fullscreen/ProductSaved.svelte';

// Routes for the "inner router"
// Note that we have a "prefix" property for this nested router
const routes = {
    '/Tour': Tour,
    '/FactorySaved/:factorySettingsId':FactorySaved,
    '/ProductSaved':ProductSaved,
}
</script>
<Router {routes} prefix="/fullscreen" />